import {
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";

import { STRING } from "../../../constants/string";
import { NgClassType } from "../../../types";

export type MedAccordionArrowPosition = "before" | "";

@Component({
  selector: "med-accordion",
  templateUrl: "./med-accordion.component.html",
  styleUrls: ["./med-accordion.component.scss"],
})
export class MedAccordionComponent {
  @Input() containerClass: string = STRING.EMPTY;
  @Input() headerClass: NgClassType = STRING.EMPTY;
  @Input() contentClass: NgClassType = STRING.EMPTY;
  @Input() active = false;
  @Input() arrowPosition: MedAccordionArrowPosition = STRING.EMPTY;

  @Output() activeChange = new EventEmitter<boolean>();

  get containerClassList(): NgClassType {
    const active: string = this.active ? "active" : STRING.EMPTY;
    return [this.containerClass, this.arrowPosition, active].join(STRING.SPACE);
  }

  setActive() {
    this.active = !this.active;
    this.activeChange.emit(this.active);
  }
}
